<script setup lang="ts">
import { faCheck, faFilterCircleXmark, faPenToSquare, faTrashCan } from '@fortawesome/pro-regular-svg-icons'

import { AppMultiSelect, AppMultiSelectSearchable, AppSelect } from '@shared/ui/selects'
import { WrapperFilters } from '@shared/ui/wrappers'
import { AppInput } from '@shared/ui/inputs'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'

import { useFiltersTutorBilling } from '../model/filters-tutor-billing.hook'
import { useFilterTutorBillingTutor } from '../model/filter-tutor-billing-tutor.hook'
import FilterDatePreset from './filters/FilterDatePreset.vue'
import FilterOpsStatus from './filters/FilterOpsStatus.vue'
import TutorBillingExportMenu from './TutorBillingExportMenu.vue'

defineOptions({
  name: 'FiltersTutorBilling',
})

const {
  search,
  paymentServices,
  changeType,
  paymentServiceOptions,
  tutorStatuses,
  tutorStatusOptions,
  changeTypeOptions,
  isLoading,
  hasSelection,
  setSearch,
  setClear,
  setOpenBulkEdit,
  setOpenBulkConfirm,
  setOpenBulkErase,
} = useFiltersTutorBilling()

const {
  tutorIds,
  tutorOptions,
  selectedTutorOptions,
  tutorHasMore,
  tutorLoading,
  onTutorSearch,
  onTutorLoadMore,
  onTutorOpen,
} = useFilterTutorBillingTutor()
</script>

<template>
  <WrapperFilters class="filters-tutor-billing">
    <AppInput
      v-model="search"
      class="filters-tutor-billing__search"
      label="Search"
      placeholder="Tutor ID, name, account owner, email, account"
      @keyup:enter="setSearch"
    />

    <AppMultiSelectSearchable
      v-model="tutorIds"
      class="filters-tutor-billing__select"
      :options="tutorOptions"
      :selected-options="selectedTutorOptions"
      :has-more="tutorHasMore"
      :loading="tutorLoading"
      label="Tutor"
      placeholder="All"
      clearable
      infinite
      @search="onTutorSearch"
      @load-more="onTutorLoadMore"
      @open="onTutorOpen"
    />

    <AppMultiSelect
      v-model="tutorStatuses"
      class="filters-tutor-billing__select"
      :options="tutorStatusOptions"
      label="Status"
      placeholder="All"
      clearable
    />

    <AppMultiSelect
      v-model="paymentServices"
      class="filters-tutor-billing__select"
      :options="paymentServiceOptions"
      label="Payment service"
      placeholder="All"
      clearable
    />

    <AppSelect
      v-model="changeType"
      class="filters-tutor-billing__select"
      :options="changeTypeOptions"
      label="Change type"
      placeholder="All"
      clearable
    />

    <FilterDatePreset />

    <FilterOpsStatus />

    <template #controls>
      <BtnIcon
        :icon="faFilterCircleXmark"
        color="red"
        tooltip-text="Clear filters"
        :disabled="isLoading"
        @click="setClear"
      />

      <BtnPrimary
        text="Search"
        element-width="auto"
        :disabled="isLoading"
        @click="setSearch"
      />

      <BtnIcon
        v-if="hasSelection"
        :icon="faPenToSquare"
        tooltip-text="Bulk edit"
        @click="setOpenBulkEdit"
      />

      <BtnIcon
        v-if="hasSelection"
        :icon="faCheck"
        color="emerald"
        tooltip-text="Confirm selected"
        @click="setOpenBulkConfirm"
      />

      <BtnIcon
        v-if="hasSelection"
        :icon="faTrashCan"
        color="red"
        tooltip-text="Erase selected"
        @click="setOpenBulkErase"
      />

      <TutorBillingExportMenu />
    </template>
  </WrapperFilters>
</template>

<style scoped lang="scss" src="./FiltersTutorBilling.scss" />
